import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_MY_ENTERPRISE } from "../../../routes";
import FormPage from "../../common/components/layout/FormPage";
import EnterpriseForm from "../components/EnterpriseForm";
import {
  updateEnterprise,
  getEnterpriseLogo,
  addEnterpriseCertificate,
  getEnterpriseCertificates,
  deleteEnterpriseCertificate,
} from "../actions/enterpriseActions";
import { getClientInfo } from "../actions/clientsActions";

class UpdateEnterprise extends FormPage {
  static propTypes = {
    updateEnterprise: func.isRequired,
    getEnterpriseLogo: func.isRequired,
    getClientInfo: func.isRequired,
    addEnterpriseCertificate: func.isRequired,
    getEnterpriseCertificates: func.isRequired,
    deleteEnterpriseCertificate: func.isRequired,
    enterprise: shape().isRequired,
    client: shape().isRequired,
    match: shape().isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
    this.createCertificate = this.createCertificate.bind(this);
    this.getCertificates = this.getCertificates.bind(this);
    this.deleteCertificate = this.deleteCertificate.bind(this);
  }

  componentDidMount() {
    const {
      getEnterpriseLogo,
      getClientInfo,
      getEnterpriseCertificates,
      match,
    } = this.props;
    let clientInfo = undefined;
    if (this.props.location.state !== undefined) {
      clientInfo = this.props.location.state.clientInfo;
    }

    if (clientInfo === undefined) {
      getClientInfo(match.params.uuid);
    } else {
      this.props.client.info = clientInfo;
    }

    getEnterpriseLogo(match.params.uuid);
    getEnterpriseCertificates(match.params.uuid);
  }

  /** {@inheritdoc} */
  getBackRoute() {
    return ROUTE_MY_ENTERPRISE;
  }

  /** {@inheritdoc} */
  getTitle() {
    const { client } = this.props;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: I18n.t("pages.my_enterprise.update.title", {
            enterprise: `<span class="form-title--secondary">${client.info.legalCompanyName}</span>`,
          }),
        }}
      />
    );
  }

  /**
   * @param {object} enterprise
   */
  onSubmit(enterprise) {
    const { updateEnterprise, match } = this.props;

    updateEnterprise(match.params.uuid, enterprise);
  }

  createCertificate(certificate) {
    const { addEnterpriseCertificate, match } = this.props;
    addEnterpriseCertificate(match.params.uuid, certificate, match.params.uuid);
  }

  getCertificates() {
    const { getEnterpriseCertificates, match } = this.props;
    getEnterpriseCertificates(match.params.uuid);
  }

  deleteCertificate(uuid) {
    const { deleteEnterpriseCertificate, match } = this.props;
    deleteEnterpriseCertificate(uuid, match.params.uuid);
  }

  /** {@inheritdoc} */
  renderContent() {
    const { enterprise, client } = this.props;

    return (
      <EnterpriseForm
        enterprise={{
          ...client.info,
          logo: enterprise.logo,
        }}
        saved={enterprise.saved || false}
        errors={enterprise.errors}
        loading={enterprise.saving}
        onSubmit={this.onSubmit}
        createCertificate={this.createCertificate}
        getCertificates={this.getCertificates}
        deleteCertificate={this.deleteCertificate}
        goBack={this.goBack}
      />
    );
  }

  render() {
    const { enterprise, client } = this.props;

    if (enterprise.logo === undefined || client.info === undefined) {
      return <div className="loader" />;
    }

    return super.render();
  }
}

const mapStateToProps = (state) => ({
  enterprise: state.enterprise,
  client: state.client,
});

const mapDispatchToProps = (dispatch) => ({
  getEnterpriseLogo: (uuid) => dispatch(getEnterpriseLogo(uuid)),
  getEnterpriseCertificates: (uuid) =>
    dispatch(getEnterpriseCertificates(uuid)),
  updateEnterprise: (uuid, enterprise) =>
    dispatch(updateEnterprise(uuid, enterprise)),
  deleteEnterpriseCertificate: (uuid, enterpriseUuid) =>
    dispatch(deleteEnterpriseCertificate(uuid, enterpriseUuid)),
  getClientInfo: (uuid) => dispatch(getClientInfo(uuid)),
  addEnterpriseCertificate: (uuid, certificate, enterpriseUuid) =>
    dispatch(addEnterpriseCertificate(uuid, certificate, enterpriseUuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateEnterprise);
